<template>
  <component
    ref="chart"
    class='vuestic-chart'
    :is="chartComponent"
    :options="options"
    :chart-data="data"
  />
</template>

<script>
//import PieChart from './chart-types/PieChart'
//import BubbleChart from './chart-types/BubbleChart'
import DonutChart from './chart-types/NewDonutChart'
//import HorizontalBarChart from './chart-types/HorizontalBarChart'
//import VerticalBarChart from './chart-types/VerticalBarChart'
//import LineChart from './chart-types/LineChart'
import { chartTypesMap } from './NewVuesticChartConfigs'

export default {
  name: 'vuestic-chart',
  props: {
    data: {},
    options: {},
    type: {
      validator (type) {
        const valid = type in chartTypesMap

        if (!valid) {
          // eslint-disable-next-line no-console
          console.warn(`There is no chart of ${type} type`)
        }

        return valid
      },
    },
  },
  components: {
    DonutChart,
  },
  computed: {
    chartComponent () {
      return chartTypesMap[this.type]
    },
  },
  async mounted() {
    }
}
</script>

<style lang='scss'>
.vuestic-chart {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}
</style>
